module.exports = __webpack_public_path__ + "static/jscamp2019-9852149b66483733c731b9da8533c46c.jpeg";